(function () {
  function initSasProduct(section) {
    if (!section || section.dataset.sasV3Ready === 'true') return;
    section.dataset.sasV3Ready = 'true';

    var variantScript = section.querySelector('[data-sas-variants]');
    var variants = [];
    try { variants = JSON.parse(variantScript ? variantScript.textContent : '[]'); } catch (e) {}

    var currency = section.getAttribute('data-currency') || 'AED';
    var variantInput = section.querySelector('[data-variant-id]');
    var priceNode = section.querySelector('[data-product-price]');
    var compareNode = section.querySelector('[data-product-compare]');
    var savingNode = section.querySelector('[data-product-saving]');
    var discountNode = section.querySelector('[data-discount-badge]');
    var inlineDiscountNode = section.querySelector('[data-inline-discount]');
    var stockNode = section.querySelector('[data-stock-label]');
    var addButton = section.querySelector('[data-add-to-cart]');
    var addLabel = section.querySelector('[data-add-label]');
    var bundleBox = section.querySelector('[data-bundle-box]');

    function setDirham(node, cents, decimals) {
      if (!node) return;
      var amount = (Number(cents || 0) / 100).toFixed(Math.max(0, Number(decimals || 0)));
      var target = node.tagName && node.tagName.toLowerCase() === 'dirham-price' ? node : node.querySelector('dirham-price');
      if (!target) {
        target = document.createElement('dirham-price');
        node.textContent = '';
        node.appendChild(target);
      }
      target.setAttribute('amount', amount);
      target.setAttribute('decimals', String(decimals));
    }

    function selectedOptions() {
      return Array.prototype.slice.call(section.querySelectorAll('[data-option-position]'))
        .sort(function (a, b) {
          return Number(a.getAttribute('data-option-position') || 0) - Number(b.getAttribute('data-option-position') || 0);
        })
        .map(function (group) {
          var checked = group.querySelector('[data-option-radio]:checked');
          return checked ? checked.value : '';
        });
    }

    function sameOptions(variant, values) {
      if (!variant || !variant.options || variant.options.length !== values.length) return false;
      for (var i = 0; i < values.length; i++) {
        if (String(variant.options[i]) !== String(values[i])) return false;
      }
      return true;
    }

    function activateMedia(mediaId) {
      if (!mediaId) return;
      var thumb = section.querySelector('[data-gallery-thumb][data-media-id="' + String(mediaId) + '"]');
      if (thumb) thumb.click();
    }

    function updateBundleMain(variant) {
      if (!bundleBox || !variant) return;
      bundleBox.setAttribute('data-main-variant-id', variant.id);
      bundleBox.setAttribute('data-main-price', variant.price);
      updateBundleTotals();
    }

    function updateFbtMain(variant) {
      if (!variant) return;
      var mainInput = section.querySelector('[data-sas-fbt-main]');
      if (!mainInput) return;

      mainInput.setAttribute('data-variant-id', variant.id);
      mainInput.setAttribute('data-price', variant.price);

      var mainPrice = section.querySelector('[data-sas-fbt-main-price]');
      if (mainPrice) setDirham(mainPrice, variant.price, 2);

      var fbtRoot = section.querySelector('[data-sas-fbt]');
      if (fbtRoot) fbtRoot.dispatchEvent(new CustomEvent('sas:fbt-refresh'));
    }

    function updateVariant() {
      var values = selectedOptions();
      if (!values.length) return;

      var variant = variants.find(function (item) { return sameOptions(item, values); });
      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (priceNode) setDirham(priceNode, variant.price, 2);

      var compare = Number(variant.compare_at_price || 0);
      var price = Number(variant.price || 0);
      var saving = compare > price ? compare - price : 0;
      var discount = compare > price ? Math.round((saving * 100) / compare) : 0;

      if (compareNode) {
        if (compare > price) setDirham(compareNode, compare, 2);
        compareNode.classList.toggle('is-hidden', !(compare > price));
      }
      if (savingNode) {
        if (saving > 0) {
          var savingPrice = savingNode.querySelector('[data-product-saving-amount]');
          if (!savingPrice) {
            savingNode.innerHTML = 'saved <dirham-price data-product-saving-amount></dirham-price>';
            savingPrice = savingNode.querySelector('[data-product-saving-amount]');
          }
          setDirham(savingPrice, saving, 0);
        }
        savingNode.classList.toggle('is-hidden', !(saving > 0));
      }
      if (discountNode) {
        discountNode.textContent = discount > 0 ? discount + '% off' : '';
        discountNode.classList.toggle('is-hidden', !(discount > 0));
      }
      if (inlineDiscountNode) {
        inlineDiscountNode.textContent = discount > 0 ? discount + '% off' : '';
        inlineDiscountNode.classList.toggle('is-hidden', !(discount > 0));
      }
      if (stockNode) {
        stockNode.classList.toggle('is-out', !variant.available);
        stockNode.innerHTML = '<span></span>' + (variant.available ? 'In stock' : 'Sold out');
      }
      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';

      if (variant.featured_media_id) activateMedia(variant.featured_media_id);
      updateBundleMain(variant);
      updateFbtMain(variant);

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }

    function updateBundleTotals() {
      if (!bundleBox) return;
      var mainPrice = Number(bundleBox.getAttribute('data-main-price') || 0);
      var subtotal = mainPrice;
      bundleBox.querySelectorAll('[data-bundle-item]:checked').forEach(function (input) {
        subtotal += Number(input.getAttribute('data-price') || 0);
      });
      var percent = Number(bundleBox.getAttribute('data-discount-percent') || 0);
      var saved = Math.round(subtotal * percent / 100);
      var total = Math.max(0, subtotal - saved);
      var totalNodes = bundleBox.querySelectorAll('[data-bundle-total], [data-bundle-button-total]');
      totalNodes.forEach(function (node) { setDirham(node, total, 2); });
      var savedNode = bundleBox.querySelector('[data-bundle-saved]');
      if (savedNode) {
        if (saved > 0) {
          savedNode.innerHTML = '(save <dirham-price></dirham-price>)';
          setDirham(savedNode, saved, 2);
        } else {
          savedNode.textContent = '';
        }
      }
    }

    section.querySelectorAll('[data-option-radio]').forEach(function (radio) {
      radio.addEventListener('change', updateVariant);
    });

    /* Product condition explainer drawer */
    var conditionTriggers = Array.prototype.slice.call(section.querySelectorAll('[data-condition-drawer-open]'));
    if (conditionTriggers.length) {
      var conditionDrawer = document.getElementById('sas-condition-definition-drawer');
      var conditionOverlay = document.getElementById('sas-condition-definition-overlay');
      var conditionClose = conditionDrawer ? conditionDrawer.querySelector('.sas-condition-definition-close') : null;
      var conditionCopyScript = section.querySelector('[data-condition-copy]');
      var conditionCopy = {};
      try { conditionCopy = JSON.parse(conditionCopyScript ? conditionCopyScript.textContent : '{}'); } catch (e) {}

      function normalizeCondition(value) {
        var key = String(value || '').trim().toLowerCase().replace(/_/g, ' ').replace(/\s+/g, ' ');
        if (key === 'brand new' || key === 'brand-new') return 'new';
        if (key === 'as is' || key === 'as-is' || key === 'used') return 'as-is';
        if (key.indexOf('excellent') !== -1) return 'excellent';
        if (key.indexOf('fair') !== -1) return 'fair';
        if (key.indexOf('new') !== -1) return 'new';
        return key;
      }

      function currentCondition() {
        var checked = section.querySelector('.sas-pdp__option--condition [data-option-radio]:checked');
        if (checked) return checked.value;
        var staticValue = section.querySelector('.sas-pdp__condition-static-value');
        return staticValue ? staticValue.textContent.trim() : 'Excellent';
      }

      function conditionLabel(key, rawValue) {
        if (key === 'new') return 'New';
        if (key === 'excellent') return 'Excellent';
        if (key === 'fair') return 'Fair';
        if (key === 'as-is') return 'As-Is';
        return rawValue || 'Condition';
      }

      function renderConditionDrawer() {
        if (!conditionDrawer) return;
        var raw = currentCondition();
        var key = normalizeCondition(raw);
        var label = conditionLabel(key, raw);
        var description = conditionCopy[key] || conditionCopy[String(raw || '').toLowerCase()] || '';

        var title = conditionDrawer.querySelector('[data-condition-drawer-title]');
        var badge = conditionDrawer.querySelector('[data-condition-drawer-badge]');
        var descriptionNode = conditionDrawer.querySelector('[data-condition-drawer-description]');
        var helpNode = conditionDrawer.querySelector('[data-condition-drawer-help]');
        var video = conditionDrawer.querySelector('[data-condition-drawer-video]');
        var videoTitle = conditionDrawer.querySelector('[data-condition-drawer-video-title]');

        if (title) title.textContent = label + ' condition';
        if (badge) badge.textContent = label;
        if (descriptionNode) descriptionNode.textContent = description || ('This product is listed in ' + label + ' condition. Please review the product details before ordering.');

        if (key === 'excellent') {
          if (helpNode) {
            helpNode.hidden = false;
            helpNode.textContent = 'To better understand what our Excellent condition means, watch the condition video below.';
          }
          if (video) video.hidden = false;
          if (videoTitle) videoTitle.textContent = 'Excellent condition video';
        } else {
          if (helpNode) helpNode.hidden = true;
          if (video) video.hidden = true;
        }
      }

      function setConditionDrawer(open) {
        if (!conditionDrawer || !conditionOverlay) return;
        if (open) renderConditionDrawer();
        conditionDrawer.classList.toggle('active', open);
        conditionOverlay.classList.toggle('active', open);
        conditionTriggers.forEach(function (trigger) {
          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        document.body.classList.toggle('overflow-hidden', open);
        if (open && conditionClose) conditionClose.focus();
      }

      conditionTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          setConditionDrawer(true);
        });
      });

      section.querySelectorAll('.sas-pdp__option--condition [data-option-radio]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (conditionDrawer && conditionDrawer.classList.contains('active')) renderConditionDrawer();
        });
      });

      if (conditionClose) {
        conditionClose.addEventListener('click', function () { setConditionDrawer(false); });
      }
      if (conditionOverlay) {
        conditionOverlay.addEventListener('click', function () { setConditionDrawer(false); });
      }
      section.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && conditionDrawer && conditionDrawer.classList.contains('active')) {
          setConditionDrawer(false);
          if (conditionTriggers[0]) conditionTriggers[0].focus();
        }
      });
    }

    /* Purchase benefit tabs: Warranty / Delivery / Returns / Payment */
    section.querySelectorAll('[data-benefit-tabs]').forEach(function (tabsRoot) {
      var tabs = Array.prototype.slice.call(tabsRoot.querySelectorAll('[data-benefit-tab]'));
      var panels = Array.prototype.slice.call(tabsRoot.querySelectorAll('[data-benefit-panel]'));
      if (!tabs.length || !panels.length) return;

      function activateBenefit(name, focusTab) {
        tabs.forEach(function (tab) {
          var active = tab.getAttribute('data-benefit-tab') === name;
          tab.classList.toggle('is-highlighted', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
          if (active && focusTab) tab.focus();
        });

        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-benefit-panel') === name;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activateBenefit(tab.getAttribute('data-benefit-tab'), false);
        });

        tab.addEventListener('keydown', function (event) {
          var nextIndex = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = tabs.length - 1;
          else return;

          event.preventDefault();
          activateBenefit(tabs[nextIndex].getAttribute('data-benefit-tab'), true);
        });
      });
    });

    if (bundleBox) {
      bundleBox.querySelectorAll('[data-bundle-item]').forEach(function (input) {
        input.addEventListener('change', updateBundleTotals);
      });
      updateBundleTotals();

      var buyBundle = bundleBox.querySelector('[data-buy-bundle]');
      if (buyBundle) {
        buyBundle.addEventListener('click', function () {
          if (buyBundle.disabled) return;
          var items = [];
          var mainId = Number(bundleBox.getAttribute('data-main-variant-id') || 0);
          if (mainId) items.push({ id: mainId, quantity: 1 });
          bundleBox.querySelectorAll('[data-bundle-item]:checked:not(:disabled)').forEach(function (input) {
            var id = Number(input.getAttribute('data-variant-id') || 0);
            if (id) items.push({ id: id, quantity: 1 });
          });
          if (!items.length) return;

          var msg = bundleBox.querySelector('[data-bundle-message]');
          buyBundle.disabled = true;
          if (msg) msg.textContent = 'Adding bundle…';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (j) { throw new Error(j.description || 'Could not add bundle'); });
            return res.json();
          })
          .then(function () {
            var code = (bundleBox.getAttribute('data-discount-code') || '').trim();
            var cartDrawer = document.querySelector('cart-drawer');

            if (code) {
              fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', {
                method: 'GET',
                headers: { 'Accept': 'application/json' }
              }).catch(function () {});
            }

            if (cartDrawer && typeof cartDrawer.reload === 'function') {
              cartDrawer.reload();
              window.setTimeout(function () {
                if (typeof cartDrawer.open === 'function') cartDrawer.open(buyBundle);
              }, 180);
            } else if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open(buyBundle);
            }
          })
          .catch(function (err) {
            buyBundle.disabled = false;
            if (msg) msg.textContent = err.message || 'Could not add bundle. Please try again.';
          });
        });
      }
    }

    var shareButton = section.querySelector('[data-share-product]');
    if (shareButton) {
      shareButton.addEventListener('click', function () {
        if (navigator.share) {
          navigator.share({ title: document.title, url: window.location.href }).catch(function () {});
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(window.location.href).catch(function () {});
        }
      });
    }
  }

  function initSasCartDrawerIntegration() {
    if (document.documentElement.dataset.sasCartDrawerIntegrationReady === 'true') return;
    document.documentElement.dataset.sasCartDrawerIntegrationReady = 'true';

    var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    var knownCartCount = null;
    var pollTimer = null;
    var pollAttempts = 0;
    var activeTrigger = null;

    function getCartDrawer() {
      return document.querySelector('cart-drawer');
    }

    function readCartCount(callback) {
      fetch(rootPath + 'cart.js', {
        method: 'GET',
        headers: { 'Accept': 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Could not read cart');
          return response.json();
        })
        .then(function (cart) {
          callback(Number(cart.item_count || 0));
        })
        .catch(function () {});
    }

    function openUpdatedDrawer(trigger) {
      var cartDrawer = getCartDrawer();
      if (!cartDrawer) return;

      if (typeof cartDrawer.reload === 'function') cartDrawer.reload();
      window.setTimeout(function () {
        if (typeof cartDrawer.open === 'function') cartDrawer.open(trigger || activeTrigger || undefined);
      }, 180);
    }

    function stopPolling() {
      if (pollTimer) window.clearTimeout(pollTimer);
      pollTimer = null;
      pollAttempts = 0;
    }

    function pollForCartChange() {
      stopPolling();
      pollAttempts = 0;

      function check() {
        readCartCount(function (count) {
          if (knownCartCount === null) {
            knownCartCount = count;
          } else if (count !== knownCartCount) {
            knownCartCount = count;
            stopPolling();
            openUpdatedDrawer(activeTrigger);
            return;
          }

          pollAttempts += 1;
          if (pollAttempts < 16) {
            pollTimer = window.setTimeout(check, 250);
          } else {
            stopPolling();
          }
        });
      }

      pollTimer = window.setTimeout(check, 120);
    }

    readCartCount(function (count) {
      knownCartCount = count;
    });

    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest
        ? event.target.closest('[data-sas-product] [data-add-to-cart], .ppcse-tot-btn, .ppcse-m-tot-lt-btn, .lb-upsell-tot-btn')
        : null;
      if (!target) return;
      activeTrigger = target;
      pollForCartChange();
    }, true);

    window.addEventListener('lb-upsell-added', function () {
      if (!document.querySelector('[data-sas-product]')) return;
      readCartCount(function (count) {
        knownCartCount = count;
      });
      openUpdatedDrawer(activeTrigger);
    }, false);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-sas-product]').forEach(initSasProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
      initSasCartDrawerIntegration();
    });
  } else {
    initAll(document);
    initSasCartDrawerIntegration();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
